import { axios, def, handleError, handleResponse } from './internal';
import { storage } from '@goldblack/client-storage';

function AdminUserUnsetLegal(userId, types, onSuccess) {
    axios
        .post('/api/admin_user_unsetlegal', { userId, types })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    storage.transience.setState('internal.success', 'Legal agreement unset.');
                    onSuccess?.(res.data.data.legal);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserUnsetLegal };
